<div class="container" id="spinerLoader" *ngIf="loader">
    <div class="loader">Loading...</div>
</div>

<div mat-dialog-title class="modal-header header-radius-4 mb-4">
    <div class="mx-3 d-flex justify-content-between align-items-center">
        <div *ngIf="!isUpdate" class="d-flex">
            <div>
                <h4>{{data.groupDetail.groupName}}</h4>
            </div>
            <div *ngIf="isLoggedInMemberAGroupAdmin">
                <span class="cursorPointer ml-3" (click)="isUpdate = true">
                    <i class="fa fa-pencil"></i>
                </span>
            </div>
        </div>
        <div *ngIf="isUpdate" class="d-flex flex-grow-1">
            <div class="form-group mb-0 pl-0 flex-grow-1 height-fit-content">
                <div class="btn card card-border d-block col-sm-12 col-xs-12">
                    <input type="text" placeholder="Enter Group name" class="border-none input-width"
                        [(ngModel)]="groupName" [value]="data.groupDetail.groupName" [maxlength]="groupNameLength"
                        (keyup)="sliceExtraText(groupNameLength)" required>
                    <span class="ml-2">{{groupNameLengthRemainingToShowOnUI}}</span>
                </div>
            </div>
            <div>
                <button type="button" class="flat-butt flat-info-butt flat-info-grad-butt font-size-14 button-height"
                    title="Save" (click)="updateGroupName()">
                    <i class="fa fa-check fa-md"></i>
                </button>
                <button type="button" class="flat-butt flat-info-butt flat-info-grad-butt font-size-14 button-height"
                    title="Cancel" (click)="resetGroupName()">
                    <i class="fa fa-close fa-md"></i>
                </button>
            </div>
        </div>
        <div class="d-flex justify-content-between align-items-center ml-4">
            <button *ngIf="isLoggedInMemberAGroupAdmin"
                class="hidden-xs add-new-member-btn cursorPointer font-size-xs-10 font-size-sm-14 px-2 mr-4"
                title="Add New Member" (click)="openAddNewMemberDialog()">
                <i class="fa fa-user-plus px-2"></i>
                <span class="pr-2">Add New Member</span>
            </button>
            <span class="hidden-sm cursorPointer" (click)="openAddNewMemberDialog()">
                <i class="fa fa-user-plus px-2 mr-4"></i>
            </span>
            <button type="button" class="close close-btn cursorPointer" mat-dialog-close>
                <i class="fa fa-close"></i>
            </button>
        </div>
    </div>
</div>
<mat-dialog-content>
    <div class="p-0 mx-4 mb-4">
        <table class="card-layout table-striped table my-0 fixed_header">
            <thead>
                <tr>
                    <td class="header_td table_heading radius-4 modal-header header-color py-4">
                        <div class="header_container px-2">
                            <div class="header_title width-10">
                                S. No.
                            </div>
                            <div class="header_title">
                                Name
                            </div>
                            <div class="header_title">
                                Role
                            </div>
                            <div class="header_title">
                                Status
                            </div>
                            <div *ngIf="isLoggedMemberAGroupAdmin()" class="header_title width-25">
                                Action
                            </div>
                        </div>
                    </td>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let member of data.memberList
                | orderBy: sortBy : sortOrder; let i = index">
                    <td>
                        <div class="row_container py-2 px-2">
                            <div class="title_container width-10">
                                <div class="row_title">S. No.</div>
                                <div class="row_detail width-10">
                                    <span>{{i + 1}}.</span>
                                </div>
                            </div>
                            <div class="title_container">
                                <div class="row_title">Name</div>
                                <div class="row_detail">
                                    <span *ngIf="member != null">
                                        {{member.memberFirstName ? member.memberFirstName : null}}
                                        {{member.memberMiddleName ? member.memberMiddleName : null}}
                                        {{member.memberLastName ? member.memberLastName : null}}
                                    </span>
                                </div>
                            </div>
                            <div class="title_container">
                                <div class="row_title">Role</div>
                                <div class="row_detail">
                                    <span>{{getMemberRoleList(member.memberRole)}}</span>
                                </div>
                            </div>
                            <div class="title_container">
                                <div class="row_title">Status</div>
                                <div class="row_detail">
                                    <span *ngIf="member.isGroupAdmin" class="badge px-4 py-2 enroute-status-colors">
                                        {{member.isGroupAdmin === true ? 'Admin' : null}}
                                    </span>
                                </div>
                            </div>
                            <div class="title_container width-25" *ngIf="isLoggedMemberAGroupAdmin()">
                                <div class="row_title">Action</div>
                                <div *ngIf="(!isInternal && user.businessUnitId === member.businessUnitId) || isInternal"
                                    class="row_detail">
                                    <button *ngIf="member.memberId !== this.user.memberId"
                                        [title]="member.isGroupAdmin ? 'Remove Admin' : 'Make Admin'"
                                        (click)="updateAdminStatus(member)"
                                        class="flat-butt flat-info-butt flat-info-grad-butt font-size-xs-10 font-size-sm-14 btn-xs-padding">
                                        {{member.isGroupAdmin ? 'Remove Admin' : 'Make Admin'}}
                                    </button>
                                    <span *ngIf="member.memberId !== this.user.memberId" (click)="removeMember(member)"
                                        title="Remove Member" class="color-red cursorPointer font-size-14 ml-3">
                                        <i class="fa fa-trash fa-lg"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</mat-dialog-content>